import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  Modal,
  Form,
  Breadcrumb
} from "react-bootstrap";
import ReactApexChart from "react-apexcharts";


import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";


import {
  FaBuilding,
  FaMapMarkerAlt,
  FaFileExport,
  FaPlus,
  FaFilePdf,
  FaFileExcel
} from "react-icons/fa";

const CompaniesPage = () => {

  const [showModal, setShowModal] = useState(false);
  const [image, setImage] = useState("");
  const fileInputRef = useRef();

  useEffect(() => {
    const savedImage = localStorage.getItem("companyImage");
    if (savedImage) setImage(savedImage);
  }, []);

  const handleUploadClick = () => fileInputRef.current.click();

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 4 * 1024 * 1024) {
      alert("Image must be below 4MB");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setImage(reader.result);
      localStorage.setItem("companyImage", reader.result);
    };

    reader.readAsDataURL(file);
  };

  /* Graph Config */

  const chartOptions = {
    chart: {
      type: "line",
      sparkline: { enabled: true }
    },
    stroke: { curve: "smooth", width: 2 },
    tooltip: {
      enabled: true
    },
    colors: ["#ff6b2c"]
  };

  const chartSeries = [
    {
      data: [5, 10, 8, 14, 12, 18, 15]
    }
  ];

  return (
    <>
 

        {/* Header */}

        <div className="d-md-flex d-block align-items-center justify-content-between mb-4">

    <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Companies</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Dashboard
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Companies List</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

          <div className="d-flex flex-wrap align-items-center">

            <Dropdown className="me-2 mb-2">
              <Dropdown.Toggle className="export-btn text-dark">
                <FaFileExport className="me-2" /> Export
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Item>
                  <FaFilePdf className="me-2 text-danger" />
                  Export as PDF
                </Dropdown.Item>

                <Dropdown.Item>
                  <FaFileExcel className="me-2 text-success" />
                  Export as Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button className="add-btn mb-2" onClick={() => setShowModal(true)}>
              <FaPlus className="me-2" />
              Add Company
            </Button>

          </div>
        </div>

        {/* CARDS */}

        <Row>

          <Col lg={3} md={6} className="mb-3 ">
            <Card className="custom-card">
              <Card.Body className="card-flex">

                <div className="d-flex align-items-center">

                  <div className="icon primary">
                    <FaBuilding />
                  </div>

                  <div className="ms-3">
                    <p className="label">Total Companies</p>
                    <h5>950</h5>
                  </div>

                </div>

                <ReactApexChart
                  options={chartOptions}
                  series={chartSeries}
                  type="line"
                  height={37}
                  width={70}
                />

              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="custom-card">
              <Card.Body className="card-flex">

                <div className="d-flex align-items-center">

                  <div className="icon success">
                    <FaBuilding />
                  </div>

                  <div className="ms-3">
                    <p className="label">Active Companies</p>
                    <h5>920</h5>
                  </div>

                </div>

                <ReactApexChart
                  options={chartOptions}
                  series={chartSeries}
                  type="line"
                  height={37}
                  width={70}
                />

              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="custom-card">
              <Card.Body className="card-flex">

                <div className="d-flex align-items-center">

                  <div className="icon danger">
                    <FaBuilding />
                  </div>

                  <div className="ms-3">
                    <p className="label">Inactive Companies</p>
                    <h5>30</h5>
                  </div>

                </div>

                <ReactApexChart
                  options={chartOptions}
                  series={chartSeries}
                  type="line"
                   height={37}
                  width={70}
                />

              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="custom-card">
              <Card.Body className="card-flex">

                <div className="d-flex align-items-center">

                  <div className="icon info">
                    <FaMapMarkerAlt />
                  </div>

                  <div className="ms-3">
                    <p className="label">Company Location</p>
                    <h5>180</h5>
                  </div>

                </div>

                <ReactApexChart
                  options={chartOptions}
                  series={chartSeries}
                  type="line"
                  height={37}
                  width={70}
                />

              </Card.Body>
            </Card>
          </Col>

        </Row>

      

      {/* MODAL */}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">

        <Modal.Header closeButton>
          <Modal.Title>Add New Company</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {/* Upload */}

          <div className="upload-box d-flex align-items-center mb-3">

            <img
              src={image || "/assets/img/default-avatar.png"}
              alt=""
              className="upload-img"
            />

            <div className="ms-3">

              <h6 className="mb-1">Upload Profile Image</h6>

              <small className="text-muted">
                Image should be below 4 mb
              </small>

              <div className="mt-2">

                <Button size="sm" className="upload-btn me-2" onClick={handleUploadClick}>
                  Upload
                </Button>

                <Button size="sm" variant="light">
                  Cancel
                </Button>

              </div>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
              />

            </div>

          </div>

          {/* FORM */}

          <Row>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Name *</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Email Address</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Account URL</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Website</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Password *</Form.Label>
                <Form.Control type="password" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Confirm Password *</Form.Label>
                <Form.Control type="password" />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-2">
                <Form.Label>Address</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plan Name *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plan Type *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Currency *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Language *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

          </Row>

        </Modal.Body>

        <Modal.Footer>

          <Button variant="light">
            Cancel
          </Button>

          <Button className="add-btn">
            Add Company
          </Button>

        </Modal.Footer>

      </Modal>

      {/* INTERNAL CSS */}

      <style>{`

      .custom-card{
     border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
        padding:3px;
        
      }

      .card-flex{
        display:flex;
        justify-content:space-between;
        align-items:center;
      }

      .icon{
        width:40px;
        height:40px;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
        color:white;
      }

      .primary{background:#ff6b2c;}
      .success{background:#28a745;}
      .danger{background:#dc3545;}
      .info{background:#17a2b8;}

      .label{
        font-size:13px;
        margin-bottom:2px;
        color:#777;
      }

      .export-btn{
        background:#fff;
        border:1px solid #ddd;
        color:"#070707"
      }

      .add-btn{
        background:#ff6b2c;
        border:none;
      }

      .upload-box{
        background:#f5f6f8;
        padding:15px;
        border-radius:10px;
      }

      .upload-img{
        width:60px;
        height:60px;
        border-radius:50%;
        object-fit:cover;
      }

      .upload-btn{
        background:#ff6b2c;
        border:none;
      }

      .modal-dialog{
        max-width:850px;
      }

      .modal-body{
        padding:20px;
        font-size:14px;
      }

      @media(max-width:768px){

        .card-flex{
          flex-direction:column;
          align-items:flex-start;
        }

        .upload-box{
          flex-direction:column;
          align-items:flex-start;
        }

      }

      `}</style>
    </>
  );
};

export default CompaniesPage;